import { render, staticRenderFns } from "./FileUploadCarousel.vue?vue&type=template&id=5820de15&scoped=true&"
import script from "./FileUploadCarousel.vue?vue&type=script&lang=js&"
export * from "./FileUploadCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadCarousel.vue?vue&type=style&index=0&id=5820de15&scoped=true&lang=css&"
import style1 from "./FileUploadCarousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820de15",
  null
  
)

export default component.exports